module.exports = __webpack_public_path__ + "img/chatt-valley.055e9260.jpg";